module.exports = __webpack_public_path__ + "img/macro03.113388e6.png";